module.exports = __webpack_public_path__ + "img/bg-1.3edb5e0e.jpg";